import { DoorOpen, Layers, LogIn, Accessibility, PersonStanding, CircleEllipsis } from "lucide-react";
import ServicePageLayout from "@/components/ServicePageLayout";
import usePageMeta from "@/hooks/usePageMeta";
import { useContent } from "@/content/ContentContext";

const APPLICATIONS = [
  {
    icon: DoorOpen,
    title: "Door Thresholds",
    copy: "Smooth out raised door sills and thresholds for easier everyday access.",
  },
  {
    icon: Layers,
    title: "Small Steps",
    copy: "Practical ramp solutions for single steps and small changes in level.",
  },
  {
    icon: LogIn,
    title: "Entry Points",
    copy: "Make coming and going through entry points simpler and safer.",
  },
  {
    icon: Accessibility,
    title: "Wheelchair Access",
    copy: "Easier wheelchair access over suitable steps and thresholds.",
  },
  {
    icon: PersonStanding,
    title: "Walker / Rollator Access",
    copy: "Smoother movement for walkers and rollators around the home.",
  },
  {
    icon: CircleEllipsis,
    title: "Other Changes in Level",
    copy: "Other suitable changes in level — send us a photo and we'll take a look.",
  },
];

export default function RubberRamps() {
  const { get } = useContent();
  usePageMeta(
    get("meta_ramps_title", "Rubber Ramps Perth | Supplied & Installed | Modify"),
    get("meta_ramps_desc", "Rubber threshold ramps supplied and professionally installed across Perth — smooth, safe access over steps and doorways. Free quote from Modify.")
  );
  return (
    <ServicePageLayout
      pageTestid="rubber-ramps-page"
      eyebrow="Rubber Ramps — Perth, WA"
      title="SIMPLE ACCESS WITH RUBBER RAMPS"
      sub="Practical rubber ramp solutions for suitable steps, thresholds and everyday access."
      heroImg="/images/ramp-hero.jpg"
      heroAlt="Rubber ramp access solution installed at a Perth home"
      enquiryTitle="NEED A RUBBER RAMP?"
      enquiryCopy="Tell us about the step or threshold, send us a photo, and we'll help you find the right solution."
      service="Rubber Ramps"
      applicationsTitle="Where rubber ramps can help."
      applications={APPLICATIONS}
      note="Every step and threshold is different. Get in touch and we'll help you work out whether a rubber ramp is the right fit for your space."
      galleryCategory="rubber-ramps"
      promo={{
        kicker: "Whole-home offer",
        title: "ONE SMOOTH ENTRY IS GOOD. EVERY ENTRY IS FREEDOM.",
        body1:
          "The step you notice every day is rarely the only one. Front door, sliding door, garage, laundry — most homes have three or four thresholds, and every one of them interrupts the journey for wheels, walkers and tired knees.",
        body2Strong: "ramps for more than one threshold",
        body2Rest:
          " Send us a photo of each step or doorway and we'll put together a whole-home package quote — one visit, better value. Just mention whole-home package pricing when you enquire.",
        chips: [
          { icon: DoorOpen, label: "Front + sliding door pairings" },
          { icon: LogIn, label: "Garage + laundry thresholds" },
          { icon: Accessibility, label: "Home + portable ramp combos" },
        ],
        image: "/images/ramp-06.jpg",
        imageAlt: "Rubber ramp fitted at a doorway threshold in Perth",
        service: "Rubber Ramps",
        ctaLabel: "GET A WHOLE-HOME QUOTE",
      }}
      ctaTitle="READY FOR SIMPLER ACCESS?"
      ctaLabel="GET A QUOTE"
    />
  );
}
